export default __webpack_public_path__ + "static/media/Ballroll_00304.70699bdf.png";